/**
 * Component that contains all routes for all logged-in pages (excluding sign up)
 */
import React from 'react';
import { Switch, Route } from 'react-router-dom';

import {
  OWNER,
  OR_ADMIN,
  OR_SUPERUSER,
  OR_READONLY,
  OR_SUPERREAD,
  ADMIN,
  READONLY,
  BILLING,
} from 'constants/roles';
import DashboardPageContainer from '../DashboardPage/DashboardPageContainer';
import InstancesPageContainer from '../InstancesPage/InstancesPageContainer';
import CreateInstancePageContainer from '../CreateInstancePage/CreateInstancePageContainer';
import CreateInstancePageContainer2 from '../CreateInstancePage2/CreateInstancePageContainer';
import ProfilePageContainer from '../ProfilePage/ProfilePageContainer';
import AuthorizedRouteContainer from '../../AuthorizedRoute/AuthorizedRouteContainer';
import InstancesPageRedirect from '../InstancesPageRedirect/InstancesPageRedirectContainer';
import InstanceDetailContainer from '../InstancesPage/InstanceDetail/InstanceDetailContainer';
import ErrorPageContainer from '../../ErrorPage/ErrorPageContainer';
import OrgImpersonationPageContainer from '../OrgImpersonationPage/OrgImpersonationPageContainer';
import UsersPageContainer from '../UsersPage/UsersPageContainer';

function MissionCtrlRoutes() {
  return (
    <Switch>
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/create-instance"
        component={CreateInstancePageContainer}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/create-instance2"
        component={CreateInstancePageContainer2}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/instances/:service/:instanceId"
        roles={[OWNER, ADMIN, READONLY, BILLING, OR_ADMIN, OR_READONLY, OR_SUPERUSER, OR_SUPERREAD]}
        component={InstanceDetailContainer}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/instances"
        roles={[OWNER, ADMIN, READONLY, BILLING, OR_ADMIN, OR_READONLY, OR_SUPERUSER, OR_SUPERREAD]}
        component={InstancesPageContainer}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/dashboard"
        component={DashboardPageContainer}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/profile"
        component={ProfilePageContainer}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/users"
        roles={[OWNER, OR_ADMIN, OR_SUPERUSER]}
        component={UsersPageContainer}
      />
      <AuthorizedRouteContainer
        exact
        path="/mission-ctrl/org-impersonation"
        roles={[OR_ADMIN, OR_READONLY]}
        component={OrgImpersonationPageContainer}
      />
      <AuthorizedRouteContainer exact path="/mission-ctrl" component={InstancesPageRedirect} />
      <Route render={() => <ErrorPageContainer match={{ params: { statusCode: '404' } }} />} />
    </Switch>
  );
}

export default MissionCtrlRoutes;
